
(function(){

  function initMvdCart(){

    const drawer =
      document.getElementById('mvd-cart-drawer');

    const overlay =
      document.getElementById('mvd-cart-overlay');

    if(!drawer || !overlay){
      return;
    }

    const path = window.location.pathname;

    const lang =
      path.indexOf('/en') === 0
        ? 'en'
        : path.indexOf('/es') === 0
          ? 'es'
          : 'fr';

    const translations = {

      fr:{
        title:'Mon Panier',
        empty:'Votre panier est vide',
        continue:'Continuer mes achats',

        free:'🎁 Félicitations, vous avez débloqué la livraison offerte !',
        missing:'Plus que {amount} pour profiter de la livraison offerte',

        remove:'Supprimer',
        save:'🏷 Vous économisez {percent} %',

        upsell:'✨ Complétez votre kit de Diamond Painting',

        add:'Ajouter au panier',
        adding:'Ajout...',
        sale:'PROMO -{percent} %',

        promo:'Un code promo ?',
        promoPlaceholder:'Votre code',
        apply:'Appliquer',
        applying:'Application...',
        promoApplied:'✓ Code promo appliqué',
        promoInvalid:'Ce code promo ne semble pas applicable.',
        promoEmpty:'Saisissez votre code promo.',

        discount:'Remises',
        savings:'Économies totales',

        checkout:'Passer la commande • {total}',

        delivery:'🚚 Livraison rapide Mondial Relay · 3–5 jours ouvrés',

        threshold:6000,
        locale:'fr-FR',
        currency:'EUR',
        prefix:'',

        collection:'/collections/accessoires-diamond-painting/products.json?limit=250'
      },

      es:{
        title:'Mi carrito',
        empty:'Tu carrito está vacío',
        continue:'Seguir comprando',

        free:'🎁 ¡Enhorabuena! Has conseguido el envío gratis.',
        missing:'Te faltan {amount} para conseguir el envío gratis',

        remove:'Eliminar',
        save:'🏷 Ahorras un {percent} %',

        upsell:'✨ Completa tu kit de Diamond Painting',

        add:'Añadir al carrito',
        adding:'Añadiendo...',
        sale:'OFERTA -{percent} %',

        promo:'¿Tienes un código promocional?',
        promoPlaceholder:'Tu código',
        apply:'Aplicar',
        applying:'Aplicando...',
        promoApplied:'✓ Código promocional aplicado',
        promoInvalid:'Este código promocional no parece aplicarse.',
        promoEmpty:'Introduce tu código promocional.',

        discount:'Descuentos',
        savings:'Ahorro total',

        checkout:'Finalizar compra • {total}',

        delivery:'🚚 Envío rápido vía InPost · 4–6 días laborables',

        threshold:6000,
        locale:'es-ES',
        currency:'EUR',
        prefix:'/es',

        collection:'/es/collections/accessoires-diamond-painting/products.json?limit=250'
      },

      en:{
        title:'My Cart',
        empty:'Your cart is empty',
        continue:'Continue shopping',

        free:'🎁 Congratulations! You unlocked Free Shipping!',
        missing:'Only {amount} away from Free Shipping',

        remove:'Remove',
        save:'🏷 You save {percent}%',

        upsell:'✨ Complete Your Diamond Painting Kit',

        add:'Add to cart',
        adding:'Adding...',
        sale:'SALE -{percent}%',

        promo:'Have a promo code?',
        promoPlaceholder:'Promo code',
        apply:'Apply',
        applying:'Applying...',
        promoApplied:'✓ Promo code applied',
        promoInvalid:'This promo code does not appear to apply.',
        promoEmpty:'Enter your promo code.',

        discount:'Discounts',
        savings:'Total savings',

        checkout:'Checkout • {total}',

        delivery:'📦 French brand • Shipping to the United States',

        threshold:7000,
        locale:'en-US',
        currency:'USD',
        prefix:'/en',

        collection:'/en/collections/accessories/products.json?limit=250'
      }

    };

    const T = translations[lang];

    const cartTitle =
      document.getElementById('mvd-cart-title');

    const closeButton =
      document.getElementById('mvd-cart-close');

    const shippingText =
      document.getElementById('mvd-shipping-text');

    const shippingProgress =
      document.getElementById('mvd-shipping-progress');

    const items =
      document.getElementById('mvd-cart-items');

    const empty =
      document.getElementById('mvd-cart-empty');

    const emptyText =
      document.getElementById('mvd-empty-text');

    const continueButton =
      document.getElementById('mvd-cart-continue');

    const upsell =
      document.getElementById('mvd-cart-upsell');

    const upsellTitle =
      document.getElementById('mvd-upsell-title');

    const slider =
      document.getElementById('mvd-upsell-slider');

    const prev =
      document.getElementById('mvd-upsell-prev');

    const next =
      document.getElementById('mvd-upsell-next');

    const promoToggle =
      document.getElementById('mvd-promo-toggle');

    const promoContent =
      document.getElementById('mvd-promo-content');

    const promoSymbol =
      document.getElementById('mvd-promo-symbol');

    const promoTitle =
      document.getElementById('mvd-promo-title');

    const promoInput =
      document.getElementById('mvd-promo-input');

    const promoApply =
      document.getElementById('mvd-promo-apply');

    const promoMessage =
      document.getElementById('mvd-promo-message');

    const activeDiscounts =
      document.getElementById('mvd-active-discounts');

    const activeDiscountsTitle =
      document.getElementById('mvd-active-discounts-title');

    const activeDiscountTags =
      document.getElementById('mvd-active-discount-tags');

    const savingTitle =
      document.getElementById('mvd-saving-title');

    const savingValue =
      document.getElementById('mvd-saving-value');

    const checkout =
      document.getElementById('mvd-checkout');

    const delivery =
      document.getElementById('mvd-delivery');

    cartTitle.textContent = T.title;
    emptyText.textContent = T.empty;
    continueButton.textContent = T.continue;
    upsellTitle.textContent = T.upsell;
    promoTitle.textContent = T.promo;
    promoInput.placeholder = T.promoPlaceholder;
    promoApply.textContent = T.apply;
    activeDiscountsTitle.textContent = T.discount;
    savingTitle.textContent = T.savings;
    delivery.textContent = T.delivery;

    let busy = false;
    let accessoryProducts = null;

    const localizedProducts = {};

    function money(cents){

      return (
        Number(cents || 0) / 100
      ).toLocaleString(
        T.locale,
        {
          style:'currency',
          currency:T.currency
        }
      );

    }

    function safeText(value){

      const temp =
        document.createElement('div');

      temp.textContent =
        String(value || '');

      return temp.innerHTML;

    }

    function openCart(){

      drawer.classList.add('mvd-open');
      overlay.classList.add('mvd-open');

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow = 'hidden';

      refresh();

    }

    function closeCart(){

      drawer.classList.remove('mvd-open');
      overlay.classList.remove('mvd-open');

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow = '';

    }

    window.openMvdCart = openCart;

    closeButton.onclick = closeCart;
    overlay.onclick = closeCart;
    continueButton.onclick = closeCart;

    document.addEventListener(
      'click',
      function(event){

        const element =
          event.target instanceof Element
            ? event.target
            : event.target.parentElement;

        if(!element){
          return;
        }

        const trigger =
          element.closest(
            'a[href*="/cart"],' +
            'button[aria-controls*="cart" i],' +
            '[aria-label*="cart" i],' +
            '[aria-label*="panier" i]'
          );

        if(!trigger){
          return;
        }

        if(
          trigger.closest('#mvd-cart-drawer')
        ){
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openCart();

      },
      true
    );

    const originalFetch =
      window.fetch.bind(window);

    window.fetch =
      function(resource, options){

        let url = '';

        if(typeof resource === 'string'){
          url = resource;
        }

        else if(resource && resource.url){
          url = resource.url;
        }

        const request =
          originalFetch(resource, options);

        if(url.indexOf('/cart/add') !== -1){

          request
            .then(function(response){

              if(response && response.ok){

                if(drawer.classList.contains('mvd-open')){

                  refresh();

                } else {

                  window.setTimeout(function(){

                    if(drawer.classList.contains('mvd-open')){
                      refresh();
                    } else {
                      openCart();
                    }

                  }, 120);

                }

              }

            })
            .catch(function(){});

        }

        return request;

      };


    // ================================================
    // PARTIE 2 - GESTION DES PRODUITS DU PANIER
    // ================================================

    async function getCart(){

      const response =
        await originalFetch(
          '/cart.js',
          {
            cache:'no-store'
          }
        );

      if(!response.ok){
        throw new Error('Cart error');
      }

      return response.json();

    }


    async function getLocalizedProduct(item){

      if(lang === 'fr'){

        return {
          title:item.product_title
        };

      }

      const handle = item.handle;

      if(!handle){

        return {
          title:item.product_title
        };

      }

      if(localizedProducts[handle]){

        return localizedProducts[handle];

      }

      try{

        const response =
          await originalFetch(
            T.prefix +
            '/products/' +
            handle +
            '.js',
            {
              cache:'force-cache'
            }
          );

        if(!response.ok){
          throw new Error();
        }

        const product =
          await response.json();

        localizedProducts[handle] =
          product;

        return product;

      }

      catch(error){

        return {
          title:item.product_title
        };

      }

    }


    // ================================================
    // MODIFIER LA QUANTITÉ D'UN PRODUIT
    // ================================================

    async function changeItem(key, quantity){

      if(busy){
        return;
      }

      busy = true;

      try{

        const response =
          await originalFetch(
            '/cart/change.js',
            {
              method:'POST',

              headers:{
                'Content-Type':'application/json'
              },

              body:JSON.stringify({
                id:key,
                quantity:quantity
              })
            }
          );

        if(!response.ok){
          throw new Error('Cart change error');
        }

        await refresh();

      }

      catch(error){

        console.error(
          'MVD change',
          error
        );

      }

      finally{

        busy = false;

      }

    }


    // ================================================
    // AJOUTER UN ACCESSOIRE AU PANIER
    // ================================================

    async function addItem(variantId){

      if(busy){
        return false;
      }

      busy = true;

      try{

        const response =
          await originalFetch(
            '/cart/add.js',
            {
              method:'POST',

              headers:{
                'Content-Type':'application/json'
              },

              body:JSON.stringify({
                items:[
                  {
                    id:Number(variantId),
                    quantity:1
                  }
                ]
              })
            }
          );

        if(!response.ok){
          throw new Error('Cart add error');
        }

        await refresh();

        return true;

      }

      catch(error){

        console.error(
          'MVD add',
          error
        );

        return false;

      }

      finally{

        busy = false;

      }

    }


    // ================================================
    // BARRE DE LIVRAISON OFFERTE
    // ================================================

    function renderShipping(cart){

      const total =
        Number(cart.total_price || 0);

      const progress =
        Math.min(
          100,
          (total / T.threshold) * 100
        );

      shippingProgress.style.width =
        progress + '%';

      if(total >= T.threshold){

        shippingText.textContent =
          T.free;

      }

      else{

        shippingText.textContent =
          T.missing.replace(
            '{amount}',
            money(T.threshold - total)
          );

      }

    }


    // ================================================
    // AFFICHAGE DES DIAMOND PAINTINGS
    // ================================================

    async function renderItems(cart){

      // Préparer les lignes en mémoire avant de
      // remplacer l'affichage du panier.
      // Cela évite les ajouts visuels partiels.

      const fragment =
        document.createDocumentFragment();

      if(cart.items.length === 0){

        items.replaceChildren();

        items.hidden = true;
        empty.hidden = false;
        upsell.hidden = true;

        return;

      }

      for(const item of cart.items){

        const localized =
          await getLocalizedProduct(item);

        const localizedTitle =
          localized && localized.title
            ? localized.title
            : item.product_title;

        const original =
          Number(
            item.original_line_price ??
            item.line_price ??
            0
          );

        const finalPrice =
          Number(
            item.final_line_price ??
            item.line_price ??
            0
          );

        let percentage = 0;

        if(
          original > finalPrice &&
          original > 0
        ){

          percentage =
            Math.round(
              ((original - finalPrice) / original) * 100
            );

        }

        const row =
          document.createElement('div');

        row.className = 'mvd-item';

        row.innerHTML =

          '<a class="mvd-item-image" href="' +
            item.url +
          '">' +

            '<img src="' +
              (item.image || '') +
            '" alt="' +
              safeText(localizedTitle) +
            '">' +

          '</a>' +

          '<div class="mvd-item-center">' +

            '<a class="mvd-item-name" href="' +
              item.url +
            '">' +

              safeText(localizedTitle) +

            '</a>' +

            (
              item.variant_title &&
              item.variant_title !== 'Default Title'

                ? '<div class="mvd-item-variant">' +
                    safeText(item.variant_title) +
                  '</div>'

                : ''
            ) +

            '<div class="mvd-qty">' +

              '<button type="button" class="mvd-minus">−</button>' +

              '<span>' +
                item.quantity +
              '</span>' +

              '<button type="button" class="mvd-plus">+</button>' +

            '</div>' +

            '<button type="button" class="mvd-remove">' +
              T.remove +
            '</button>' +

          '</div>' +

          '<div class="mvd-item-right">' +

            '<span class="mvd-item-price">' +
              money(finalPrice) +
            '</span>' +

            (
              original > finalPrice

                ? '<span class="mvd-item-old-price">' +
                    money(original) +
                  '</span>'

                : ''
            ) +

            (
              percentage > 0

                ? '<span class="mvd-save-percent">' +
                    T.save.replace(
                      '{percent}',
                      percentage
                    ) +
                  '</span>'

                : ''
            ) +

          '</div>';


        // Bouton moins
        row.querySelector(
          '.mvd-minus'
        ).onclick = function(){

          changeItem(
            item.key,
            Math.max(
              0,
              item.quantity - 1
            )
          );

        };


        // Bouton plus
        row.querySelector(
          '.mvd-plus'
        ).onclick = function(){

          changeItem(
            item.key,
            item.quantity + 1
          );

        };


        // Bouton supprimer
        row.querySelector(
          '.mvd-remove'
        ).onclick = function(){

          changeItem(
            item.key,
            0
          );

        };


        fragment.appendChild(row);

      }

      // Remplacement unique de l'affichage.
      items.replaceChildren(fragment);

      items.hidden = false;
      empty.hidden = true;
      upsell.hidden = false;

    }


    // ================================================
    // PARTIE 3 - REDUCTIONS ET CODES PROMO
    // ================================================

    function getDiscountDetails(cart){

      const discounts = [];

      function addDiscount(name, amount){

        const cleanName =
          String(name || '').trim();

        const cleanAmount =
          Math.max(
            0,
            Number(amount || 0)
          );

        if(!cleanName || cleanAmount <= 0){
          return;
        }

        const existing =
          discounts.find(function(discount){

            return (
              discount.name.toLowerCase() ===
              cleanName.toLowerCase()
            );

          });

        if(existing){

          existing.amount += cleanAmount;

        } else {

          discounts.push({
            name:cleanName,
            amount:cleanAmount
          });

        }

      }


      // ================================================
      // REDUCTIONS AU NIVEAU DU PANIER
      // ================================================

      if(
        Array.isArray(
          cart.cart_level_discount_applications
        )
      ){

        cart.cart_level_discount_applications.forEach(
          function(app){

            addDiscount(
              app.title || app.code,
              app.total_allocated_amount
            );

          }
        );

      }


      // ================================================
      // REDUCTIONS SUR LES PRODUITS
      // ================================================

      if(Array.isArray(cart.items)){

        cart.items.forEach(function(item){

          if(
            !Array.isArray(
              item.line_level_discount_allocations
            )
          ){
            return;
          }

          item.line_level_discount_allocations.forEach(
            function(allocation){

              const app =
                allocation.discount_application || {};

              addDiscount(
                app.title || app.code,
                allocation.amount
              );

            }
          );

        });

      }

      return discounts;

    }


    // ================================================
    // RECUPERER LES NOMS DES REMISES
    // ================================================

    function getDiscountNames(cart){

      return getDiscountDetails(cart).map(
        function(discount){

          return discount.name;

        }
      );

    }


    // ================================================
    // AFFICHAGE DES REMISES
    // ================================================

    function renderDiscounts(cart){

      const discounts =
        getDiscountDetails(cart);

      if(discounts.length === 0){

        activeDiscounts.hidden = true;
        activeDiscountTags.innerHTML = '';

        return;

      }

      activeDiscounts.hidden = false;
      activeDiscountTags.innerHTML = '';

      discounts.forEach(function(discount){

        const row =
          document.createElement('div');

        row.className =
          'mvd-discount-row';

        row.innerHTML =

          '<span class="mvd-discount-tag">' +

            safeText(discount.name) +

          '</span>' +

          '<strong class="mvd-discount-amount">' +

            '-' + money(discount.amount) +

          '</strong>';

        activeDiscountTags.appendChild(row);

      });

    }


    // ================================================
    // ECONOMIES TOTALES ET BOUTON COMMANDER
    // ================================================

    function renderSummary(cart){

      let original = 0;
      let finalPrice = 0;

      cart.items.forEach(function(item){

        original +=
          Number(
            item.original_line_price ??
            item.line_price ??
            0
          );

        finalPrice +=
          Number(
            item.final_line_price ??
            item.line_price ??
            0
          );

      });

      const saving =
        Math.max(
          Number(cart.total_discount || 0),
          original - finalPrice
        );

      savingValue.textContent =
        saving > 0
          ? '-' + money(saving)
          : money(0);

      checkout.textContent =
        T.checkout.replace(
          '{total}',
          money(cart.total_price)
        );

      checkout.href = '/checkout';

      renderDiscounts(cart);

    }


    // ================================================
    // OUVERTURE DU CHAMP CODE PROMO
    // ================================================

    let promoOpen = false;

    promoToggle.onclick = function(){

      promoOpen = !promoOpen;

      promoContent.hidden = !promoOpen;

      promoSymbol.textContent =
        promoOpen ? '−' : '+';

    };


    // ================================================
    // APPLICATION D'UN CODE PROMO
    // ================================================

    promoApply.onclick = async function(){

      const code =
        promoInput.value.trim();

      if(!code){

        promoMessage.textContent =
          T.promoEmpty;

        return;

      }

      promoApply.disabled = true;
      promoApply.textContent = T.applying;
      promoMessage.textContent = '';

      try{

        await originalFetch(
          '/discount/' +
          encodeURIComponent(code) +
          '?redirect=/cart',
          {
            credentials:'same-origin',
            cache:'no-store'
          }
        );

        await new Promise(function(resolve){

          setTimeout(resolve, 250);

        });

        // Actualisation sécurisée du panier
        await refresh();

        const updated =
          await getCart();

        const names =
          getDiscountNames(updated);

        const found =
          names.some(function(name){

            return (
              name.toLowerCase().indexOf(
                code.toLowerCase()
              ) !== -1
            );

          });

        promoMessage.textContent =
          found
            ? T.promoApplied
            : T.promoInvalid;

      }

      catch(error){

        console.error(
          'MVD promo',
          error
        );

        promoMessage.textContent =
          T.promoInvalid;

      }

      finally{

        promoApply.disabled = false;
        promoApply.textContent = T.apply;

      }

    };


    // ================================================
    // APPLIQUER AVEC LA TOUCHE ENTREE
    // ================================================

    promoInput.addEventListener(
      'keydown',
      function(event){

        if(event.key === 'Enter'){

          event.preventDefault();

          promoApply.click();

        }

      }
    );


    // ================================================
    // PARTIE 4 - ACCESSOIRES RECOMMANDES
    // ================================================

    async function loadAccessories(){

      if(accessoryProducts){
        return accessoryProducts;
      }

      try{

        const response =
          await originalFetch(
            T.collection,
            {
              cache:'no-store'
            }
          );

        if(!response.ok){
          throw new Error();
        }

        const data =
          await response.json();

        accessoryProducts =
          data.products || [];

        return accessoryProducts;

      }

      catch(error){

        accessoryProducts = [];

        return [];

      }

    }


    // ================================================
    // BENEFICES DES ACCESSOIRES
    // ================================================

    function productBenefit(product){

      const text =
        (
          (product.handle || '') +
          ' ' +
          (product.title || '')
        )
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'');


      // Stylo multi-embouts

      if(
        text.indexOf('embouts-metalliques') !== -1 ||
        text.indexOf('metal-tips') !== -1 ||
        text.indexOf('puntas-metalicas') !== -1
      ){

        return lang === 'fr'
          ? '⚡ Posez plusieurs diamants à la fois'
          : lang === 'es'
            ? '⚡ Coloca varios diamantes a la vez'
            : '⚡ Place multiple diamonds at once';

      }


      // Valise 60 cellules

      if(
        text.indexOf('valise') !== -1 ||
        text.indexOf('60-cell') !== -1 ||
        text.indexOf('60-cellules') !== -1 ||
        text.indexOf('60 compartimentos') !== -1
      ){

        return lang === 'fr'
          ? '🧰 Rangez vos diamants et votre matériel'
          : lang === 'es'
            ? '🧰 Guarda tus diamantes y tu material'
            : '🧰 Store your diamonds & tools';

      }


      // Boîte 56 cellules

      if(
        text.indexOf('56-cell') !== -1 ||
        text.indexOf('56-cellules') !== -1 ||
        text.indexOf('56 compartimentos') !== -1
      ){

        return lang === 'fr'
          ? '💎 Organisez et séparez facilement vos diamants'
          : lang === 'es'
            ? '💎 Organiza y separa fácilmente tus diamantes'
            : '💎 Easily organize & separate your diamonds';

      }


      // Plateau de tri

      if(
        text.indexOf('plateau') !== -1 ||
        text.indexOf('sorting-tray') !== -1 ||
        text.indexOf('tray') !== -1 ||
        text.indexOf('bandeja') !== -1
      ){

        return lang === 'fr'
          ? '🛡️ Plus pratique et limite les renversements'
          : lang === 'es'
            ? '🛡️ Más práctico y ayuda a evitar derrames'
            : '🛡️ Easier to use and helps prevent spills';

      }


      // Classeur de rangement

      if(
        text.indexOf('classeur') !== -1 ||
        text.indexOf('binder') !== -1 ||
        text.indexOf('portfolio') !== -1 ||
        text.indexOf('carpeta') !== -1 ||
        text.indexOf('album') !== -1
      ){

        return lang === 'fr'
          ? '🖼️ Protégez et rangez vos créations terminées'
          : lang === 'es'
            ? '🖼️ Protege y guarda tus creaciones terminadas'
            : '🖼️ Protect & store your finished creations';

      }


      // Tablette lumineuse

      if(
        text.indexOf('tablette-lumineuse') !== -1 ||
        text.indexOf('light-pad') !== -1 ||
        text.indexOf('light-board') !== -1 ||
        text.indexOf('light-table') !== -1 ||
        text.indexOf('lumineuse') !== -1
      ){

        return lang === 'fr'
          ? '💡 Distinguez les symboles plus facilement'
          : lang === 'es'
            ? '💡 Distingue los símbolos más fácilmente'
            : '💡 See the symbols more easily';

      }


      // Pince

      if(
        text.indexOf('pince') !== -1 ||
        text.indexOf('tweezer') !== -1 ||
        text.indexOf('tweezers') !== -1 ||
        text.indexOf('pinza') !== -1
      ){

        return lang === 'fr'
          ? '🎯 Ajustez et retirez vos diamants avec précision'
          : lang === 'es'
            ? '🎯 Ajusta y retira tus diamantes con precisión'
            : '🎯 Adjust & remove diamonds with precision';

      }


      // Cadre

      if(
        text.indexOf('cadre') !== -1 ||
        text.indexOf('frame') !== -1 ||
        text.indexOf('marco') !== -1
      ){

        return lang === 'fr'
          ? '✨ Exposez votre création une fois terminée'
          : lang === 'es'
            ? '✨ Expón tu creación una vez terminada'
            : '✨ Display your creation once finished';

      }


      // Boîte de rangement

      if(
        text.indexOf('boite') !== -1 ||
        text.indexOf('storage') !== -1 ||
        text.indexOf('box') !== -1 ||
        text.indexOf('rangement') !== -1 ||
        text.indexOf('caja') !== -1
      ){

        return lang === 'fr'
          ? '💎 Gardez votre matériel parfaitement organisé'
          : lang === 'es'
            ? '💎 Mantén todo tu material perfectamente organizado'
            : '💎 Keep your supplies perfectly organized';

      }


      // Description par défaut

      return lang === 'fr'
        ? '✨ Rendez votre Diamond Painting encore plus agréable'
        : lang === 'es'
          ? '✨ Haz que tu Diamond Painting sea aún más agradable'
          : '✨ Make your Diamond Painting experience even better';

    }


    // ================================================
    // AFFICHAGE DES ACCESSOIRES
    // ================================================

    async function renderUpsell(cart){

      const products =
        await loadAccessories();

      const fragment =
        document.createDocumentFragment();

      const cartIds =
        cart.items.map(function(item){

          return Number(item.product_id);

        });


      products.forEach(function(product){

        // Ne pas recommander un produit
        // déjà présent dans le panier

        if(
          cartIds.indexOf(
            Number(product.id)
          ) !== -1
        ){
          return;
        }


        const variant =
          product.variants.find(function(v){

            return v.available;

          }) || product.variants[0];


        if(!variant){
          return;
        }


        // Prix de l'accessoire

        const productPrice =
          Math.round(
            parseFloat(
              variant.price || 0
            ) * 100
          );


        // Ancien prix barré

        const comparePrice =
          variant.compare_at_price
            ? Math.round(
                parseFloat(
                  variant.compare_at_price
                ) * 100
              )
            : 0;


        // Pourcentage de réduction

        let salePercent = 0;

        if(
          comparePrice > productPrice &&
          comparePrice > 0
        ){

          salePercent =
            Math.round(
              (
                (comparePrice - productPrice) /
                comparePrice
              ) * 100
            );

        }


        // Image de l'accessoire

        let image = '';

        if(
          product.images &&
          product.images.length
        ){

          image =
            product.images[0].src ||
            product.images[0];

        }


        // URL du produit

        const productUrl =
          T.prefix +
          '/products/' +
          product.handle;


        const card =
          document.createElement('div');

        card.className =
          'mvd-upsell-card';


        // Badge de promotion

        const saleBadge =
          salePercent > 0

            ? '<span class="mvd-upsell-sale-badge">' +
                T.sale.replace(
                  '{percent}',
                  salePercent
                ) +
              '</span>'

            : '';


        // Prix barré

        const oldPrice =
          salePercent > 0

            ? '<span class="mvd-upsell-old-price">' +
                money(comparePrice) +
              '</span>'

            : '';


        // ================================================
        // CONSTRUCTION DE LA CARTE ACCESSOIRE
        // ================================================

        card.innerHTML =

          '<a class="mvd-upsell-image-wrap" href="' +
            productUrl +
          '">' +

            saleBadge +

            '<img src="' +
              image +
            '">' +

          '</a>' +


          '<div>' +

            '<a class="mvd-upsell-name" href="' +
              productUrl +
            '">' +

              safeText(product.title) +

            '</a>' +


            '<span class="mvd-upsell-benefit">' +

              productBenefit(product) +

            '</span>' +


            '<div class="mvd-upsell-prices">' +

              '<span class="mvd-upsell-price">' +

                money(productPrice) +

              '</span>' +

              oldPrice +

            '</div>' +


            '<button type="button" class="mvd-upsell-add">' +

              T.add +

            '</button>' +

          '</div>';


        // ================================================
        // BOUTON AJOUTER AU PANIER
        // ================================================

        const button =
          card.querySelector(
            '.mvd-upsell-add'
          );

        button.onclick = async function(){

          button.disabled = true;

          button.textContent =
            T.adding;

          await addItem(variant.id);

          button.disabled = false;

          button.textContent =
            T.add;

        };


        fragment.appendChild(card);

      });


      // Remplacer les anciennes recommandations
      // par les nouvelles, sans accumulation.

      slider.replaceChildren(fragment);

    }


    // ================================================
    // NAVIGATION DU CARROUSEL ACCESSOIRES
    // ================================================

    prev.onclick = function(){

      slider.scrollBy({
        left:-330,
        behavior:'smooth'
      });

    };


    next.onclick = function(){

      slider.scrollBy({
        left:330,
        behavior:'smooth'
      });

    };
    
    // =========================================
    // MVD - FERMER LES ACCESSOIRES COMPLÉMENTAIRES
    // =========================================

    const upsellClose = document.createElement('button');

    upsellClose.type = 'button';
    upsellClose.className = 'mvd-upsell-close';
    upsellClose.innerHTML = '&times;';

    upsellClose.setAttribute(
      'aria-label',
      lang === 'en'
        ? 'Hide accessories'
        : lang === 'es'
          ? 'Ocultar accesorios'
          : 'Masquer les accessoires'
    );

    // Placer la croix après la flèche droite
    next.insertAdjacentElement('afterend', upsellClose);

    upsellClose.onclick = function(){
      upsell.hidden = true;
    };

    // Garder les accessoires fermés pendant
    // les actualisations du panier
    let upsellDismissed = false;

    upsellClose.onclick = function(){
      upsellDismissed = true;
      upsell.hidden = true;
    };



    // ================================================
    // PARTIE 5 - ACTUALISATION SÉCURISÉE DU PANIER
    // ================================================

    let refreshRunning = false;
    let refreshPending = false;
    let refreshPromise = null;

    async function refresh(){

      if(refreshRunning){

        refreshPending = true;

        return refreshPromise;

      }

      refreshRunning = true;

      refreshPromise = (async function(){

        try{

          do{

            refreshPending = false;

            // Récupérer le panier Shopify
            const cart = await getCart();

            // Actualiser la livraison
            renderShipping(cart);

            // Afficher les produits
            await renderItems(cart);

            // Actualiser les montants
            renderSummary(cart);

            // Actualiser les accessoires
            await renderUpsell(cart);

          } while(refreshPending);

        }

        catch(error){

          console.error(
            'MVD CART',
            error
          );

        }

        finally{

          refreshRunning = false;
          refreshPromise = null;

        }

      })();

      return refreshPromise;

    }


    // ================================================
    // ÉVÉNEMENTS SHOPIFY
    // ================================================

    document.addEventListener(
      'cart:refresh',
      refresh
    );

    document.addEventListener(
      'cart:updated',
      refresh
    );

    document.addEventListener(
      'mvd:cart-refresh',
      refresh
    );

    document.addEventListener(
      'mvd:cart-open',
      openCart
    );


    // Initialisation du panier
    refresh();

  }


  // ================================================
  // INITIALISATION APRÈS CHARGEMENT DE LA PAGE
  // ================================================

  if(document.readyState === 'loading'){

    document.addEventListener(
      'DOMContentLoaded',
      initMvdCart
    );

  }

  else{

    initMvdCart();

  }

})();


// ====================================================
// MA VILLE EN DIAMANT
// SUPPRESSION DES CODES PROMO MANUELS
// Compatible FR / EN / ES
// ====================================================

(function(){

  "use strict";

  const TAGS_ID =
    "mvd-active-discount-tags";

  let updating = false;
  let refreshTimer = null;
  let observer = null;


  // ================================================
  // LANGUE
  // ================================================

  function getLanguage(){

    const path =
      window.location.pathname;

    if(path.startsWith("/en")){
      return "en";
    }

    if(path.startsWith("/es")){
      return "es";
    }

    return "fr";

  }


  const messages = {

    fr:{
      remove:"Retirer cette remise",
      error:"Impossible de retirer la remise."
    },

    en:{
      remove:"Remove this discount",
      error:"Unable to remove the discount."
    },

    es:{
      remove:"Eliminar este descuento",
      error:"No se ha podido eliminar el descuento."
    }

  };


  const T =
    messages[getLanguage()];


  // ================================================
  // RÉCUPÉRER LE PANIER SHOPIFY
  // ================================================

  async function getCart(){

    const response =
      await fetch(
        "/cart.js",
        {
          credentials:"same-origin",
          cache:"no-store"
        }
      );

    if(!response.ok){

      throw new Error(
        "Cart unavailable"
      );

    }

    return response.json();

  }


  // ================================================
  // IDENTIFIER LES CODES PROMO MANUELS
  // ================================================

  function getManualDiscounts(cart){

    const names = new Set();

    function inspect(application){

      if(!application){
        return;
      }

      const type =
        String(
          application.type || ""
        ).toLowerCase();

      if(type !== "discount_code"){
        return;
      }

      const name =
        String(
          application.title ||
          application.code ||
          ""
        ).trim();

      if(name){

        names.add(
          name.toLowerCase()
        );

      }

    }


    (
      cart.cart_level_discount_applications || []
    ).forEach(inspect);


    (cart.items || []).forEach(function(item){

      (
        item.line_level_discount_allocations || []
      ).forEach(function(allocation){

        inspect(
          allocation.discount_application
        );

      });

    });


    return names;

  }


  // ================================================
  // SUPPRIMER UN CODE PROMO
  // ================================================

  async function removeDiscount(button){

    if(updating){
      return;
    }

    updating = true;

    button.disabled = true;
    button.style.opacity = "0.45";

    try{

      const response =
        await fetch(
          "/cart/update.js",
          {
            method:"POST",

            credentials:"same-origin",

            headers:{
              "Content-Type":"application/json",
              "Accept":"application/json"
            },

            body:JSON.stringify({
              discount:""
            })
          }
        );

      if(!response.ok){

        throw new Error(
          "Shopify HTTP " +
          response.status
        );

      }


      // Actualiser le panier personnalisé

      document.dispatchEvent(
        new Event("mvd:cart-refresh")
      );

      document.dispatchEvent(
        new Event("cart:updated")
      );


      window.setTimeout(function(){

        updateButtons();

      }, 400);

    }

    catch(error){

      console.error(
        "[MVD] Suppression remise :",
        error
      );

      alert(T.error);

      button.disabled = false;
      button.style.opacity = "1";

    }

    finally{

      updating = false;

    }

  }


  // ================================================
  // AJOUTER LES CROIX SUR LES CODES PROMO
  // ================================================

  async function updateButtons(){

    if(updating){
      return;
    }

    const container =
      document.getElementById(
        TAGS_ID
      );

    if(!container){
      return;
    }

    const rows =
      container.querySelectorAll(
        ".mvd-discount-row"
      );

    if(!rows.length){
      return;
    }

    let cart;

    try{

      cart = await getCart();

    }

    catch(error){

      return;

    }


    const manualCodes =
      getManualDiscounts(cart);


    rows.forEach(function(row){

      const label =
        row.querySelector(
          ".mvd-discount-tag"
        );

      if(!label){
        return;
      }

      const name =
        label.textContent
          .trim()
          .toLowerCase();

      const existing =
        row.querySelector(
          ".mvd-remove-discount"
        );


      // Ne pas afficher de croix
      // sur les remises automatiques

      if(!manualCodes.has(name)){

        if(existing){
          existing.remove();
        }

        return;

      }


      if(existing){
        return;
      }


      const button =
        document.createElement(
          "button"
        );

      button.type = "button";

      button.className =
        "mvd-remove-discount";

      button.textContent = "×";

      button.setAttribute(
        "aria-label",
        T.remove
      );

      button.title = T.remove;


      // ================================================
      // STYLE DU BOUTON SUPPRIMER
      // ================================================

      button.style.cssText = [

        "display:inline-flex",
        "align-items:center",
        "justify-content:center",
        "width:20px",
        "height:20px",
        "padding:0",
        "margin-left:7px",
        "border:1px solid #D9D9D9",
        "border-radius:50%",
        "background:#FFFFFF",
        "color:#555555",
        "font-size:17px",
        "font-weight:500",
        "line-height:1",
        "cursor:pointer",
        "flex-shrink:0",
        "vertical-align:middle"

      ].join(";");


      // Survol de la croix

      button.addEventListener(
        "mouseenter",
        function(){

          if(!button.disabled){

            button.style.background =
              "#F6EAEA";

            button.style.color =
              "#A33333";

          }

        }
      );


      button.addEventListener(
        "mouseleave",
        function(){

          button.style.background =
            "#FFFFFF";

          button.style.color =
            "#555555";

        }
      );


      // Clic sur la croix

      button.addEventListener(
        "click",
        function(event){

          event.preventDefault();
          event.stopPropagation();

          removeDiscount(button);

        }
      );


      label.insertAdjacentElement(
        "afterend",
        button
      );

    });

  }


  // ================================================
  // SURVEILLER LES ACTUALISATIONS DU PANIER
  // ================================================

  function scheduleUpdate(){

    if(refreshTimer){

      clearTimeout(
        refreshTimer
      );

    }

    refreshTimer =
      setTimeout(function(){

        refreshTimer = null;

        updateButtons();

      }, 250);

  }


  // ================================================
  // INITIALISER LA SURVEILLANCE
  // ================================================

  function init(){

    const container =
      document.getElementById(
        TAGS_ID
      );

    if(!container){

      setTimeout(
        init,
        500
      );

      return;

    }


    if(observer){

      observer.disconnect();

    }


    observer =
      new MutationObserver(
        scheduleUpdate
      );


    observer.observe(
      container,
      {
        childList:true,
        subtree:true
      }
    );


    scheduleUpdate();

  }


  // ================================================
  // DÉMARRAGE
  // ================================================

  if(document.readyState === "loading"){

    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once:true
      }
    );

  }

  else{

    init();

  }

})();

